module.exports = __webpack_public_path__ + "abc58f4164614c3807fd607f8c401adb.png";